// src/config.js

function trimRight(value) {
  return String(value || '').replace(/\/+$/, '');
}

function browserOrigin() {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }

  return window.location.origin;
}

function runtimeValue(key) {
  if (typeof window === 'undefined') {
    return '';
  }

  const cfg = window.__RANGI_CONFIG__ || {};
  return String(cfg[key] || '').trim();
}

function envValue(key) {
  return String(process.env[key] || '').trim();
}

function pickConfigValue(key, fallback) {
  return runtimeValue(key) || envValue(key) || fallback;
}

// Для коробочной поставки главный вариант — относительный API.
// Тогда один и тот же frontend-образ работает на любом домене заказчика.
const API_URL = trimRight(
  pickConfigValue('REACT_APP_API_URL', '/api/v1')
);

// Socket.IO по умолчанию подключается к тому же домену,
// на котором открыт frontend.
const SOCKET_URL = trimRight(
  pickConfigValue('REACT_APP_SOCKET_URL', browserOrigin())
);

// Нужен для ссылок вида /uploads/...
const API_ORIGIN = (() => {
  if (/^https?:\/\//i.test(API_URL)) {
    return trimRight(API_URL.replace(/\/api\/v\d+\/?$/i, ''));
  }

  return '';
})();

function resolveBackendUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;

  return `${API_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}

export { API_URL, SOCKET_URL, API_ORIGIN, resolveBackendUrl };
export default API_URL;